module.exports = __webpack_public_path__ + "static/media/login-app-background.d88bca5e.svg";